import PropTypes from 'prop-types';
import React from 'react';
import Header from 'src/components/header';
import Loader from 'src/components/loader';
import NotFound from 'src/components/not-found';
import {
  RUN_ACTIONS,
  RUN_ACTIONS_VERBOSE,
} from 'src/utils/constants';
import userPropType from 'src/utils/user-prop-type';

const RunActionPageWrapper = ({
  id,
  user,
  action,
  actionTarget,
  httpError,
  customErrorText,
  isLoading,
  children,
  loadingText,
}) => {
  if (httpError || customErrorText) {
    return (
      <>
        <Header excludeFromHistory title="Error" user={user} />
        {
          httpError ? (
            <main role="main" className="text-center">
              <NotFound id={id} />
            </main>
          ) : (
            <div className="alert alert-danger m-4" role="alert">
              <h1 className="h5 header-margin">Error</h1>
              {
                customErrorText ?
                  (<p className="mb-0">{customErrorText}</p>) :
                  (<p className="mb-0">Something Went Wrong.</p>)
              }
            </div>
          )

        }
      </>
    );
  }

  let verboseAction = actionTarget
    ? `${RUN_ACTIONS_VERBOSE[action]} for ${actionTarget}`
    : RUN_ACTIONS_VERBOSE[action];

  return (
    <>
      <Header title={verboseAction} user={user} />
      <main role="main" className="text-center d-flex justify-content-center">
        {isLoading ? <Loader inline text={loadingText} className="text-muted" /> : children}
      </main>
    </>
  );
};

RunActionPageWrapper.propTypes = {
  id: PropTypes.string,
  action: PropTypes.oneOf(Object.values(RUN_ACTIONS)).isRequired,
  user: userPropType,
  httpError: PropTypes.shape({}),
  customErrorText: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
  actionTarget: PropTypes.string,
};

RunActionPageWrapper.defaultProps = {
  id: '',
  user: null,
  children: null,
  httpError: null,
  customErrorText: '',
  isLoading: false,
};

export default RunActionPageWrapper;
